<template>
    <div class="my-title">
        {{ title }}
        <div class="eng">
            {{ engTitle }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyTitle',
    props: {
        title: String,
        engTitle: String
    },
}
</script>

<style lang="scss" scoped>
.my-title {
    font-family: Source Han Sans CN;
    font-size: 32px;
    font-weight: 900;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0px;
    margin-bottom: 25px;
    .eng {
        font-family: DINCond-Black;
        font-size: 24px;
        font-weight: 500;
        line-height: 100%;
        text-align: center;
        letter-spacing: 0px;

        background: linear-gradient(180deg, rgba(114, 126, 182, 0.26) 4%, #727EB6 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        z-index: 1;
    }
}
</style>